/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface BootstrapResponse
 */
export interface BootstrapResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BootstrapResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BootstrapResponse
     */
    message?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BootstrapResponse
     */
    alreadyConfigured?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BootstrapResponse
     */
    entityTypesConfigured?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BootstrapResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof BootstrapResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof BootstrapResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof BootstrapResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the BootstrapResponse interface.
 */
export function instanceOfBootstrapResponse(value: object): value is BootstrapResponse {
    return true;
}

export function BootstrapResponseFromJSON(json: any): BootstrapResponse {
    return BootstrapResponseFromJSONTyped(json, false);
}

export function BootstrapResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BootstrapResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'alreadyConfigured': json['alreadyConfigured'] == null ? undefined : json['alreadyConfigured'],
        'entityTypesConfigured': json['entityTypesConfigured'] == null ? undefined : json['entityTypesConfigured'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function BootstrapResponseToJSON(json: any): BootstrapResponse {
    return BootstrapResponseToJSONTyped(json, false);
}

export function BootstrapResponseToJSONTyped(value?: BootstrapResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'alreadyConfigured': value['alreadyConfigured'],
        'entityTypesConfigured': value['entityTypesConfigured'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

